














import Vue from "vue";
import WorldViewForm from "@/components/organisms/WorldViewForm.vue";
import ImageSelector from "@/components/molecules/ImageSelector.vue";
import { callApi } from "@/lib/api";
import { submitImage } from "@/lib/image-save";

export default Vue.extend({
  components: { WorldViewForm, ImageSelector },
  props: {
    novelId: String,
    worldViewFolderId: String,
  },
  data() {
    return {
      model: {
        detail: [],
        additionalColumn: [],
      },
      image: "",
      saving: false,
    };
  },
  methods: {
    change() {
      this.setModified(true);
    },
    async submit() {
      if (this.saving) {
        return;
      }
      try {
        this.saving = true;
        const { novelId, worldViewFolderId, image } = this;
        const CreateWorldView = `
        mutation CreateWorldView($input: CreateWorldViewInput!) {
          createWorldView ( input: $input ) {
            worldViewId
            novelId
          }  
        }`;
        const { additionalColumn } = this.model;
        this.model.additionalColumn = additionalColumn.filter((item) => item.label || item.content);
        const { createWorldView } = await callApi(CreateWorldView, {
          input: {
            novelId,
            worldViewFolderId,
            ...this.model,
            image,
          },
        });
        const worldViewId = createWorldView.worldViewId;
        await submitImage(`novels/${novelId}/worldviews/${worldViewId}.jpg`);

        this.$ga.event("novel", "create-worldview", "世界観新規作成", 0);
        this.setModified(false);
        this.$router.push({
          name: "worldViews",
          params: { novelId, worldViewId },
        });
      } finally {
        this.saving = false;

        this.$notify({
          title: "保存しました",
          type: "success",
        });
      }
    },
  },
});
